/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInAppMessages} from '../api'

 export const useQueryGetInAppMessages = createReactQueryHook('getInAppMessages', getInAppMessages)
